import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_FINGERPRINT: GlameraIconDefinition = {
  name: 'fingerprint',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-0" d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-1" d="M14 13.12c0 2.38 0 6.38-1 8.88"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-2" d="M17.29 21.02c.12-.6.43-2.3.5-3.02"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-3" d="M2 12a10 10 0 0 1 18-6"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-4" d="M2 16h.01"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-5" d="M21.8 16c.2-2 .131-5.354 0-6"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-6" d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-7" d="M8.65 22c.21-.66.45-1.32.57-2"></path>
    <path class="glm-fingerprint-ridge glm-fingerprint-ridge-8" d="M9 6.8a6 6 0 0 1 9 5.2v2"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-fingerprint-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './fingerprint.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FingerprintIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_FINGERPRINT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
